import React, { useCallback, useMemo } from 'react';

import Immediately, { StepsStates } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/Immediately';
import { useGetPaymentMethods } from '@/modules/transaction/components/ReimburseMe/queries/useGetPaymentMethods.query';
import { useStore } from '@/modules/transaction/components/ReimburseMe/store/usePaymentMethods.store';
import { PaymentMethod } from '@/modules/transaction/components/ReimburseMe/types/payment.types';
import { useOrganizationProperties } from '@/modules/transaction/hooks';
import { useAuthStore } from '@/modules/user';

interface Props {
  onClose: () => void;
  onSave: (id?: string) => void;
}

const ChoosePaymentMethodWrapper: React.FC<Props> = ({ onClose, onSave }) => {
  const { user } = useAuthStore();
  const employeeId = useMemo(() => {
    return user?.employee?.id || ''; 
  }, [user?.employee?.id]);
  const { organizationProperties } = useOrganizationProperties();
  const handleSetPaymentMethods = useStore((state) => state.handleSetPaymentMethods);
  const handleGettingPaymentMethods = useCallback((paymentMethods: PaymentMethod[]) => {
    handleSetPaymentMethods(
      paymentMethods
        .filter(
          (method) => method?.paymentMethodOwner?.employeeId === employeeId,
        ),
    );
  }, [employeeId, handleSetPaymentMethods]);
  const { isLoading } = useGetPaymentMethods(handleGettingPaymentMethods);
  return (
    <Immediately
      isLoading={isLoading}
      type="full"
      allowedPaymentMethodConfigs={organizationProperties?.allowedPaymentMethodConfigs}
      defaultStep={StepsStates.depositOrDebit}
      onClose={onClose}
      onSave={onSave}
      isRejectionFlow
    />
  );
};

export default ChoosePaymentMethodWrapper;
